import {
  DRUG_FETCH,
  DRUG_CLEAR,
  MEDICAL_SUPPLY_FETCH,
  MEDICAL_SUPPLY_CLEAR
} from '../actions/types';

const initialState = {
  data: [],
  medicalSupplyData: []
};

export default function DrugReducer(state = initialState, action = {
  type: undefined
}) {
  switch (action.type) {
    case DRUG_FETCH:
      return { ...state, ...action.playload };
    case MEDICAL_SUPPLY_FETCH:
      return { ...state, ...action.playload };
    case DRUG_CLEAR:
      return { ...state, status: undefined, message: undefined };
    case MEDICAL_SUPPLY_CLEAR:
      return { ...state, medicalSupplyStatus: undefined, medicalSupplyMessage: undefined };
    default:
      return { ...state };
  }
}
